// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__feature__underline[data-v-2c70e2a0]{border-bottom:6px solid #165fd8;width:80%;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = exports;
